import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import {
  getSurveyDefinition,
  type SurveyDefinition,
  type SurveyLegacyConfig,
  type SurveyV2Config,
} from '@/features/survey/api/surveys'

/**
 * BE-141 / BE-152 — `GET /surveys/{key}/config`; off (key null) until the dialog opens.
 * The route answers `Cache-Control: public, max-age=300` with an `ETag`; the browser
 * revalidates, this cache keeps the parsed definition for the hour.
 */
export const useSurveyDefinitionQuery = <Config = SurveyV2Config | SurveyLegacyConfig>(
  key: MaybeRef<string>,
  enabled: MaybeRef<boolean> = true,
) => {
  return createQuery<SurveyDefinition<Config>>({
    key: computed(() => (unref(enabled) ? ['surveys', 'definition', unref(key)] : null)),
    fetcher: async () => {
      const response = await getSurveyDefinition<Config>(unref(key))
      return response.data
    },
    staleTime: 60 * 60 * 1000,
  })
}
